import React from 'react';

import './loading.css';
import { Spin } from 'antd';

const Loading = () => {
  return (
    <div className="loading" data-testid="loading-overlay">
      <Spin size={'large'} />
    </div>
  );
};

export default Loading;
